<template>
  <div class="home" :class="therapistList && 'active'">
    <header class="header">
      <div class="header__wrapper">
        <div class="header__logo">
          <img class="logo" src="/img/logo.svg" alt="">
        </div>
        <div class="header__info">
          <div class="header__select">
            <TDropDown :active="therapist" :list="therapistList" :disabled="isAdmin" @change="changeTherapist" />
          </div>
          <div class="header__btn">
            <div class="btn btn_outline" @click="logout">
              Log out
            </div>
          </div>
        </div>
      </div>
    </header>
    <div class="nav">
      <div class="container">
        <div class="nav__wrapper">
          <div class="nav__title">
            Therapist Portal
          </div>
          <div class="nav__switch">
            <Switcher :active="activeTab" @change="changeTab" />
          </div>
        </div>
      </div>
    </div>
    <div class="home__wrapper" v-if="activeTab === 'list'">
      <div class="container" v-if="!loading && data.length > 0">
        <div class="home__search" />
        <div class="home__table">
          <div class="list">
            <div class="list__header">
              <div class="list__item col-1">
                <b>Patient Name</b>
              </div>
              <div class="list__item col-2">
                <b>Case</b>
              </div>
              <div class="list__item col-3">
                <b>Last Visit</b>
              </div>
              <div class="list__item col-4">
                <b>Next Visit</b>
              </div>
              <div class="list__item col-5" />
            </div>
          </div>
          <div v-for="item in data" :key="item.id" class="list" :class="{active: item.show, [bgVariant(item)]: true}">
            <div class="list__header" @click="() => showData(item)">
              <div class="list__item col-1">{{ item.patient.last_name }}, {{ item.patient.first_name }}</div>
              <div class="list__item col-2">{{ item.description }}</div>
              <div class="list__item col-3" v-if="item.last_visit_at">{{ item.last_visit_at | formatDate }}</div>
              <div class="list__item col-3" v-else>None</div>
              <div class="list__item col-4" v-if="item.next_visit_at">{{ item.next_visit_at | formatDate }}</div>
              <div class="list__item col-3" v-else>None</div>
              <div class="list__item col-5">
                <div class="show-more" v-if="item.lead">
                  <div class="show-more__text">
                    {{ item.show ? 'Show less' : 'Show more' }}
                  </div>
                  <img class="show-more__arrow" src="/img/icon/arrow-down.svg" alt="">
                </div>
                <div class="show-more" v-else>NO LEAD</div>
              </div>
            </div>
            <div class="list__content" v-if="item.lead">
              <div class="table">
                <div class="table__header">
                  <div class="table__col col-1">Case Info</div>
                  <div class="table__col col-2">Visit Info</div>
                  <div class="table__col col-3">Notes</div>
                  <div class="table__col col-4">Forms</div>
                  <div class="table__col col-5">Doctor/Other Info</div>
                </div>
                <div class="table__body">
                  <div class="table__row">
                    <div class="table__col col-1">
                      <div class="table__item">
                        <div class="table__title">
                          Case:
                        </div>
                        <div class="table__value">
                          {{ item.description }}
                        </div>
                      </div>
                      <div class="table__item">
                        <div class="table__title">
                          Name:
                        </div>
                        <div class="table__value">
                          {{ item.patient.last_name }}, {{ item.patient.first_name }}
                        </div>
                      </div>
                      <div class="table__item">
                        <div class="table__title">
                          Primary Insurance:
                        </div>
                        <div class="table__value">
                          {{ item.lead.verification.length > 0 ? item.lead.verification[item.lead.verification.length - 1].insurance_name : '' }}
                        </div>
                      </div>
                      <div class="table__item">
                        <div class="table__title">
                          Ins Available Visits:
                        </div>
                        <div class="table__value">
                          {{ item.lead.ins_available_visits }}
                        </div>
                      </div>
                      <div class="table__item">
                        <div class="table__title">
                          Prescribed Visit Total:
                        </div>
                        <div class="table__value">
                          {{ item.total_prescribed_visits }}
                        </div>
                      </div>
                      <div class="table__item">
                        <div class="table__title">
                          Patient status:
                        </div>
                        <div class="table__value">
                          {{ item.status }}
                        </div>
                      </div>
                    </div>
                    <div class="table__col col-2">
                      <div class="table__item">
                        <div class="table__title">
                          Last visit
                        </div>
                        <div class="table__value">
                          {{  item.last_visit_at | formatDate }}
                        </div>
                      </div>
                      <div class="table__item">
                        <div class="table__title">
                          Rx Count
                        </div>
                        <div class="table__value">
                          {{ item.total_prescribed_visits }}
                        </div>
                      </div>
                      <div class="table__item">
                        <div class="table__title">
                          Ins Avail
                        </div>
                        <div class="table__value">
                          {{ item.lead.ins_available_visits }}
                        </div>
                      </div>
                      <div class="table__item">
                        <div class="table__title">
                          Treated
                        </div>
                        <div class="table__value">
                          {{ item.last_visit_app_count }}
                        </div>
                      </div>
                      <div class="table__item">
                        <div class="table__title">
                          Scheduled
                        </div>
                        <div class="table__value">
                          {{ item.scheduled_visit_count }}
                        </div>
                      </div>
                      <div class="table__item">
                        <div class="table__title">
                          Total
                        </div>
                        <div class="table__value">
                          {{ item.scheduled_visit_count + item.last_visit_app_count  }}
                        </div>
                      </div>
                      <div class="table__item">
                        <div class="table__title">
                          Forecast
                        </div>
                        <div class="table__value">
                          <input
                              type="number"
                              class="input grey"
                              v-model="item.lead.total_visit_forecast"
                              @input="(value) => formHandler(item.id, 'total_visit_forecast', value.target.value)"
                          >
                        </div>
                      </div>
                      <div class="table__item">
                        <div class="table__title">
                          Next visit
                        </div>
                        <div v-if="item.next_visit_at" class="table__value">
                          {{ item.next_visit_at | formatDate }}
                        </div>
                        <div v-else class="table__value">
                          None
                        </div>
                      </div>
                    </div>
                    <div class="table__col col-3">
                      <div class="table__item">
                        <div class="table__title">
                          Ops To Therapist
                        </div>
                        <div class="table__value">
                          {{ item.lead.last_note_to_ops }}
                        </div>
                      </div>
                      <div class="table__item">
                        <div class="table__title">
                          Last Therapist to Ops
                        </div>
                        <div class="table__value">
                          {{ item.last_therapist_to_ops }}
                        </div>
                      </div>
                      <div class="table__item">
                        <div class="table__title">
                          New Therapist Note to Ops:
                        </div>
                        <div class="table__value">
                        <textarea
                            class="textarea grey"
                            maxlength="255"
                            placeholder="Type here.."
                            v-model="item.lead.new_therapist_note_to_ops"
                            @input="(value) => formHandler(item.id, 'new_therapist_note_to_ops', value.target.value)"
                        />
                        </div>
                      </div>
                    </div>
                    <div class="table__col col-4">
                      <div class="table__item">
                        <div class="table__title">
                          Forms to Send:
                        </div>
                        <div class="table__value">
                          <v-select
                              class="select"
                              :options="formstoSend"
                              v-model="item.lead.forms_to_send"
                              @input="(value) => formHandler(item.id, 'forms_to_send', value)"
                          />
                        </div>
                      </div>
                      <div class="table__item">
                        <div class="table__value">
                          <Checkbox
                              :label="'Collect forms at Eval'"
                              v-model="item.collect_forms_at_eval"
                              @input="(value) => formHandler(item.id, 'collect_forms_at_eval', value)"
                          />
                          <Checkbox
                              :label="'Collect CC form at Eval'"
                              v-model="item.collect_cc_form_at_eval"
                              @input="(value) => formHandler(item.id, 'collect_cc_form_at_eval', value)"
                          />
                          <Checkbox
                              :label="'Collect Copies of Ins. Card at Eval'"
                              v-model="item.collect_copies_of_ins_ca"
                              @input="(value) => formHandler(item.id, 'collect_copies_of_ins_ca', value)"
                          />
                          <Checkbox
                              :label="'RX Received'"
                              v-model="item.rx_received"
                              @input="(value) => formHandler(item.id, 'rx_received', value)"
                          />
                          <Checkbox
                              :label="'Forms Received'"
                              v-model="item.forms_received"
                              @input="(value) => formHandler(item.id, 'forms_received', value)"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="table__col col-5">
                      <div class="table__item">
                        <div class="table__title">
                          Doctor Name:
                        </div>
                        <div class="table__value">
                          {{ item.doctor && (`${item.doctor.last_name}, ${item.doctor.first_name}`) }}
                        </div>
                      </div>
                      <div class="table__item">
                        <div class="table__title">
                          Specialty:
                        </div>
                        <div class="table__value">
                          {{ item.doctor && item.doctor.specialty }}
                        </div>
                      </div>
                      <div class="table__item">
                        <div class="table__title">
                          Last Doctor Visit:
                        </div>
                        <div class="table__value">
                          {{ item.last_dr_visit }}
                        </div>
                      </div>
                      <div class="table__item">
                        <div class="table__title">
                          Future Doctor Visit:
                        </div>
                        <div class="table__value">
                          <Datepicker
                              class="date-picker grey"
                              v-model="item.future_dr_visit"
                              @input="(value) => datePicker(item.id, 'future_dr_visit', value)"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="table__btn">
                    <div class="btn btn_fill" :class="formLoading && 'loading'" @click="() => submit(item)">
                      Submit
                    </div>
                  </div>
                  <div class="no-data" v-if="data.length === 0">
                    Not Found
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="preloader" v-if="loading" />
      <div class="no-data" v-if="data.length === 0 && !loading">
        No Patients
      </div>
    </div>
    <div v-else class="home__wrapper">
      <div class="container">
        <Map :therapistId="therapist.id" :therapists="therapistList" />
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Datepicker from 'vuejs-datepicker';
import TDropDown from '@/components/TDropDown.vue';
import Checkbox from '@/components/Checkbox.vue';
import Switcher from '@/components/Switch.vue';
import Map from '@/components/Map.vue';

export default {
  name: 'Home',
  components: {
    TDropDown,
    Checkbox,
    Datepicker,
    Switcher,
    Map
  },
  data() {
    return {
      activeTab: 'list',
      isAdmin: false,
      loading: true,
      formLoading: false,
      therapist: null,
      therapistList: null,
      data: [],
      user: null,
      formstoSend: [
        'Cash',
        'Medicare',
        'Private',
        'Blue Shield',
        'Paper Forms',
      ],
      checkbox: false,
      form: {},
    };
  },
  mounted() {
    this.getUserInfo();
  },
  filters: {
    formatDate(date) {
      if (date) {
        date = new Date(date);
        const y = date.getFullYear();
        const m = date.getMonth() + 1;
        const d = date.getDate();
        return `${y}/${m < 10 ? '0'+m : m}/${d < 10 ? '0'+d : d}`;
      } else {
        return 'None';
      }
    },
  },
  methods: {
    async getUserInfo() {
      try {
        const res = await this.axios.get('/api/whoami');
        if (res) {
          this.user = res;
          if (this.user.role === 'Ops') {
            this.isAdmin = true;
            this.getTherapist();
          } else {
            this.isAdmin = false;
            this.therapistList = [this.user];
            this.changeTherapist(this.user);
          }
        } else {
          this.logout();
        }
      } catch (e) {
        this.logout();
      }
    },
    async getTherapist() {
      try {
        this.therapistList = await this.axios.get('/api/therapists');
        this.changeTherapist(this.therapistList[0]);
      } catch (e) {
        console.log(e);
      }
    },

    async getData() {
      this.loading = true;
      this.form = {};
      try {
        this.data = await this.axios.get(`/api/tportal/${this.therapist.id}`);
      } catch (e) {
        console.log(e);
      }
      this.loading = false;
    },

    async submit(item) {
      this.formLoading = true;

      if(this.form[item.id]) {
        try {
          const data = { ...this.form[item.id] };
          if (Object.keys(data).length > 0) {
            const res = await this.axios.post(`/api/leads/${item.lead_id}`, data);
            console.log(res);
          }
        } catch (e) {
          console.log(e);
        }
      }

      this.formLoading = false;
    },

    changeTherapist(data) {
      this.therapist = data;
      if (this.activeTab === 'list') {
        this.getData();
      }
    },

    changeTab(tab) {
      this.activeTab = tab;
      if (this.activeTab === 'list') {
        this.getData();
      }
    },

    datePicker(id, key, value) {
      this.formHandler(id, key, this.formatDate(value));
    },

    formHandler(id, key, value) {
      if (!this.form[id]) {
        this.form[id] = {};
      }

      this.form[id][key] = value;
    },

    logout() {
      window.localStorage.removeItem('authtoken');
      this.$router.replace('/login');
    },

    showData(data) {
      if (!data.lead) return
      this.data = this.data.map(item => {
       if (item.id === data.id) {
         item.show = !item.show
       }
       return item;
     })
    },

    bgVariant(c) {
      if ((!c.lead) ||
        (((c.last_visit_app_count + c.scheduled_visit_count) > c.total_prescribed_visits) &&
          (c.payers != undefined))
        )
        return 'row-red';
      else if (c.status === 'On Hold')
        return 'row-blue';
      else if ((c.scheduled_visit_count < 2 && c.last_visit_at && (c.last_visit_app_count + c.scheduled_visit_count) < c.total_forecast_visits) || (c.scheduled_visit_count === 0))
        return 'row-yellow';
      return 'light';
    },

    formatDate(date) {
      const y = date.getFullYear();
      const m = date.getMonth() + 1;
      const d = date.getDate();
      return `${y}-${m < 10 ? '0'+m : m}-${d < 10 ? '0'+d : d}`;
    },
  },
};
</script>

<style lang="scss">
  .bg-input {
    height: 40px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    padding: 0 15px;
    margin-top: 5px;
  }
  .select {
    .dropdown li {
      background-color: red;
    }
    &.vs--open {
      .vs__search {
        padding: 0 7px;
      }
      .vs__dropdown-toggle {
        border: 1px solid #979797 !important;
        border-radius: 8px;
      }
    }
    .vs__dropdown-toggle {
      padding: 4px 0 6px;
      border-radius: 8px;
      border: 1px solid #979797;
      background-color: #ffffff;
    }
    &_blue {
      .vs__dropdown-toggle {
        background-color: #e0f2fc;
      }
    }
    .vs__actions {
      padding: 4px 16px 0 3px;
    }
    .vs__selected {
      font-size: 16px;
      color: #666666;
      font-weight: 600;
      font-family: 'Montserrat', sans-serif;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      max-width: 142px;
      display: inline-block;
    }
    .vs__search {
      font-size: 16px;
      color: #666666;
      font-weight: 600;
      padding: 0;
      font-family: 'Montserrat', sans-serif;
    }
    .vs__dropdown-option--highlight {
      background-color: rgba(#fea478, .2);
    }
    .vs__selected-options {
      padding: 0 2px 0 10px;
      max-width: 100%;
    }
    &.vs--open .vs__open-indicator {
      transform: rotate(180deg) scale(.85) !important;
    }
    .vs__open-indicator {
      fill: #00234e;
      transform: scale(.85);
    }
    .vs__clear {
      display: none !important;
    }
    .vs__dropdown-menu {
      border: 1px solid #e5e5e5;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.25);
      background-color: #fff;
      top: 40px;
      border-radius: 4px;
      padding: 0;
      .vs__selected-options {
        background-color: red;
      }
      li {
        font-size: 14px;
        padding: 7px 19px;
        color: #666666;
        font-weight: 400;
        white-space: nowrap;
        max-width: 100%;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
  }

  .search {
    .dropdown li {
      background-color: red;
    }
    &.vs--open {
      .vs__dropdown-toggle {
        border: 1px solid #979797 !important;
        border-radius: 4px;
      }
    }
    .vs__dropdown-toggle {
      padding: 4px 0 6px;
      border-radius: 4px;
      border: 1px solid #979797;
      background-color: #ffffff;
      height: 44px;
    }
    .vs__actions {
      padding: 4px 16px 0 3px;
    }
    .vs__selected, input {
      font-size: 16px;
      color: #9aa1af;
      font-weight: 400;
      font-family: 'Montserrat', sans-serif;
      height: 28px;
    }
    .vs__dropdown-option--highlight {
      background-color: rgba(#fea478, .2);
    }
    .vs__selected-options {
      padding: 0 2px 0 10px;
    }
    &.vs--open .vs__open-indicator {
      transform: rotate(180deg) scale(.85) !important;
    }
    .vs__open-indicator {
      fill: #00234e;
      transform: scale(.85);
    }
    .vs__clear {
      display: none !important;
    }
    .vs__dropdown-menu {
      border: 1px solid #e5e5e5;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.25);
      background-color: #fff;
      top: 40px;
      border-radius: 4px;
      padding: 0;
      li {
        font-size: 14px;
        padding: 7px 19px;
        color: #666666;
        font-weight: 400;
      }
    }
  }

  .table {
    background-color: #ffffff;
    border-radius: 8px;
    &__header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
      font-size: 16px;
      color: #fff;
      font-weight: 400;
      border-radius: 8px 8px 0 0;
      overflow: hidden;
      .table__col {
        display: flex;
        align-items: center;
        height: 54px;
        padding: 0 16px;
        border-right: 1px solid #fff;
        background-color: #00234e;
        box-sizing: border-box;
        &:last-child {
          border: none;
        }
      }
    }
    &__body {
      height: 560px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .table__col {
        box-sizing: border-box;
        padding: 0 15px;
        &:first-child {
          padding-left: 24px;
        }
        &:last-child {
          padding-right: 24px;
        }
      }
    }
    &__row {
      display: flex;
      padding: 40px 0 0 0;
    }
    &__col {
      &-wrap {
        width: 47%;
      }
      &.col {
        &-1 {
          width: 240px;
          min-width: 240px;
        }
        &-2 {
          width: 218px;
          min-width: 218px;
        }
        &-3 {
          width: 430px;
          min-width: 430px;
        }
        &-4 {
          width: 228px;
          min-width: 228px;
        }
        &-5 {
          width: 222px;
          min-width: 222px;
        }
      }
    }
    &__item {
      margin-bottom: 16px;
      width: 100%;
      &-inline {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
    &__title {
      color: #9aa1af;
      font-size: 16px;

    }
    &__value {
      color: #666666;
      font-size: 16px;
      font-weight: 600;
      .text {
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        padding: 0 8px;
        margin: 11px 0;
      }
    }
    &__btn {
      display: flex;
      justify-content: flex-end;
      padding: 0 24px 13px 0;
      .btn {
        width: 220px;
      }
    }
    .input {
      margin-top: 8px;
    }
    .textarea {
      margin-top: 8px;
    }
    .select {
      margin-top: 8px;
    }
    .checkbox {
      margin-bottom: 15px;
    }
    .date-picker {
      margin-top: 8px;
    }
  }

  .header {
    background-color: #fff;
    box-shadow: 0 1px 0 rgba(114, 114, 114, 0.3);
    &__wrapper {
      max-width: 1120px;
      height: 70px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 auto;
      padding: 0 15px;
    }
    &__logo {

    }
    &__info {
      display: flex;
      align-items: center;
    }
    &__select {
      padding-right: 30px;
      border-right: 1px solid #e5e5e5;
    }
    &__btn {
      padding-left: 24px;
    }
  }

  .logo {
    width: 100px;
    height: 39px;
    display: block;
  }

  .btn {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 35px;
    padding: 0 15px;
    border-radius: 6px;
    font-size: 18px;
    cursor: pointer;
    z-index: 1;
    transition: .3s;
    &_outline {
      background-image: linear-gradient(to right, #941abd 0%, #f61f7e 49%, #fea478 100%);
      color: #f61f7e;
      &:before {
        content: "";
        position: absolute;
        left: 1px;
        right: 1px;
        top: 1px;
        bottom: 1px;
        background-color: #fff;
        border-radius: 6px;
        z-index: -1;
      }
    }
    &_fill {
      background-image: linear-gradient(to right, #941abd 0%, #f61f7e 49%, #fea478 100%);
      color: #fff;
    }
    &.loading {
      opacity: .5;
      pointer-events: none;
    }
  }

  .nav {
    display: flex;
    align-items: center;
    height: 77px;
    background-color: #00234e;
    &__wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    &__title {
      font-size: 24px;
      font-weight: 700;
      color: #fff;
    }
  }

  .container {
    padding: 0 15px;
    width: 100%;
    max-width: 1390px;
    margin: 0 auto;
    box-sizing: border-box;
  }

  .home {
    opacity: 0;
    transition: .3s;
    pointer-events: none;
    overflow: hidden;
    &.active {
      opacity: 1;
      pointer-events: auto;
    }
    &__wrapper {
      background-color: #eff0f2;
      min-height: calc(100vh - 147px);
      padding: 1px 0;
    }
    &__btn {
      display: flex;
    }
    &__search {
      padding: 25px 0;
      width: 343px;
    }
    &__table {
      margin-bottom: 25px;
    }
    &__btn {
      padding-bottom: 30px;
    }
  }

  .input {
    width: 100%;
    max-width: 100%;
    height: 40px;
    border-radius: 8px;
    border: 1px solid #979797;
    background-color: #ffffff;
    padding: 8px;
    box-sizing: border-box;
    font-size: 14px;
    color: #666666;
    resize: none;
    font-family: 'Montserrat', sans-serif;
    font-weight: 600;
    &:focus, &:active {
      border: 1px solid #979797;
      outline: none;
    }
    &.grey {
      background-color: #eff0f2;
    }
  }

  .textarea {
    width: 100%;
    max-width: 100%;
    height: 100px;
    border-radius: 8px;
    border: 1px solid #979797;
    background-color: #ffffff;
    padding: 8px;
    box-sizing: border-box;
    font-size: 14px;
    color: #666666;
    resize: none;
    font-family: 'Montserrat', sans-serif;
    &:focus, &:active {
      border: 1px solid #979797;
      outline: none;
    }
    &.grey {
      background-color: #eff0f2;
    }
  }

  .date-picker {
    position: relative;
    max-width: 193px;
    width: 193px;
    &.grey {
      input {
        background-color: #eff0f2;
      }
    }
    .vdp-datepicker__calendar {
      top: 104%;
      right: 0;
    }
    &__top {
      .vdp-datepicker__calendar {
        top: auto;
        bottom: 104%;
      }
    }
    &:before {
      content: "";
      position: absolute;
      width: 24px;
      height: 24px;
      background-image: url('/img/icon/calendar.svg');
      top: 7px;
      right: 15px;
      z-index: 1;
      pointer-events: none;
    }
    input {
      font-family: 'Montserrat', sans-serif;
      border-radius: 5px;
      background-color: #ffffff;
      border: 1px solid #979797;
      height: 40px;
      display: flex;
      align-items: center;
      font-size: 16px;
      color: #666666;
      width: 100%;
      padding: 0 15px;
      position: relative;
      &:focus, &:active {
        border: 1px solid #979797;
        outline: none;
      }
    }

    .prev, .next {
      color: #00234e;
    }
    .day__month_btn {
      font-weight: 700;
    }
    .vdp-datepicker__calendar {
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);
      border-radius: 6px;
      border: 1px solid #e5e5e5;
      background-color: #ffffff;
      color: #00234e;
      font-size: 16px;
      font-family: 'Montserrat', sans-serif;
      font-weight: 400;
      .cell.selected {
        background-color: #00234e;
        color: #fff;
      }
      .cell:not(.blank):not(.disabled).day:hover {
        border-color: #00234e;
      }
      .cell.selected:hover {
        background-color: #00234e;
      }
    }
  }

  .no-data {
    width: 100%;
    padding: 100px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    color: #666666;
    font-weight: 600;
  }

  .preloader::after {
    position: absolute;
    top: 0;
    bottom: 4%;
    right: 0;
    left: 0;

    content: " ";
    display: block;

    margin: auto;
    height: 32px;
    width: 32px;

    box-sizing: border-box;
    border: solid;
    border-width: 4px;
    border-radius: 50%;
    border-top-color: rgba(140, 140, 140, 0.55);
    border-bottom-color: rgba(140, 140, 140, 0.2);
    border-right-color: rgba(140, 140, 140, 0.2);
    border-left-color: rgba(140, 140, 140, 0.2);

    animation: rotating 0.9s linear infinite;
  }

  .list {
    border-radius: 4px;
    border: 1px solid #c8ced3;
    overflow: hidden;
    &.active {
      .list__content {
        transition: .3s;
        height: 623px;
      }
      .show-more {
        &__arrow {
          transform: scaleY(-1);
        }
      }
    }
    &__header {
      overflow: hidden;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 43px;
      font-size: 16px;
      font-weight: 400;
      color: #30353a;
    }
    &__content {
      padding: 0 10px;
      transition: .3s;
      height: 0;
    }
    &__item {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      padding: 0 15px;
      b {
        font-weight: 700;
        color: #23282c;
      }
      &.col {
        &-1 {
          width: 340px;
          padding-left: 25px;
        }
        &-2 {
          width: 410px;
        }
        &-3 {
          width: 250px;
        }
        &-4 {
          width: 250px;
        }
        &-5 {
          min-width: 110px;
        }
      }
    }
    &.row-blue {
      background-color: #e0f2fc;
      .bg-input {
        background-color: #e0f2fc;
      }
    }
    &.row-yellow {
      background-color: #fff2d1;
      .bg-input {
        background-color: #fff2d1;
      }
    }
    &.row-red {
      background-color: #ff9999;
    }
    &.light {
      background-color: #f0f3f5;
      .bg-input {
        background-color: #f0f3f5;
      }
    }
  }

  .show-more {
    font-size: 14px;
    color: #7a858f;
    font-weight: 400;
    display: flex;
    align-items: center;
    &__text {
      width: 82px;
    }
    &__arrow {
      width: 12px;
      margin: 0 0 -1px 15px;
      transition: .3s;
      transform: scaleY(1);
    }
  }

  @keyframes rotating{
    from {
      transform:rotate(0deg);
    }
    to {
      transform:rotate(360deg);
    }
  }
</style>
